module.exports = __webpack_public_path__ + "img/Grupo-1582.3df9c120.svg";